import {
  InfoForm,
  User,
  UserData,
  UserForm,
  UserOnlineData,
} from "../types/user";
import { authFetcher } from "./../utils/auth-fetch";

const getMe = async () => {
  return await authFetcher<User>("GET", "/owner-users");
};

const getUser = async (id: string) => {
  return await authFetcher<User>("GET", `users/${id}`);
};

const getUsers = async (params: Record<string, any> = {}) => {
  return await authFetcher<UserData>("GET", "users", null, {
    ...params,
  });
};

const createAdmin = async (data: UserForm) => {
  return await authFetcher<User>("POST", "users/admin", data);
};

const createMember = async (data: UserForm) => {
  return await authFetcher<User>("POST", "users/member", data);
};

const createCrm = async (data: UserForm) => {
  return await authFetcher<User>("POST", "users/crm", data);
};

const createReward = async (data: UserForm) => {
  return await authFetcher<User>("POST", "users/reward", data);
};

const updateInfo = async (data: InfoForm) => {
  return await authFetcher<User>("PATCH", "owner-users", data);
};

const updateInfoPassword = async (password: {
  old_password: string;
  new_password: string;
}) => {
  return await authFetcher<User>(
    "PATCH",
    `owner-users/change-password`,
    password,
  );
};

const updateUser = async (id: string, data: UserForm) => {
  return await authFetcher<User>("PATCH", `users/${id}/info`, data);
};

const updateUserPassword = async (
  id: string,
  password: { new_password: string },
) => {
  return await authFetcher<User>("PATCH", `users/${id}/password`, password);
};

const enableUser = async (id: string) => {
  return await authFetcher<any>("PATCH", `users/${id}/enable`);
};

const disableUser = async (id: string) => {
  return await authFetcher<any>("PATCH", `users/${id}/disable`);
};

const getOnlineUsers = async () => {
  return await authFetcher<UserOnlineData>("GET", "online-users");
};

const forceLogout = async (id: string) => {
  return await authFetcher<any>("POST", `users/${id}/force-logout`);
};

const getUsersSearch = async (params: Record<string, any> = {}) => {
  return await authFetcher<User[]>("GET", "users-search", null, {
    ...params,
  });
};

export {
  createAdmin,
  createCrm,
  createMember,
  createReward,
  disableUser,
  enableUser,
  forceLogout,
  getMe,
  getOnlineUsers,
  getUser,
  getUsers,
  getUsersSearch,
  updateInfo,
  updateInfoPassword,
  updateUser,
  updateUserPassword,
};
